import { useEffect } from 'react';

import { usePermissions } from 'src/common/hooks/usePermissions';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useBreadcrumbStore } from 'src/common/stores/BreadcrumbStore';

import { getMfaBreadcrumbRoutes } from '../helpers/MfaDashboardHelpers';

export const useSetMfaBreadcrumbs = (sessionId: string, sessionName: string): void => {
	const { updateBreadcrumbRoutes, setBreadcrumbRoutes } = useBreadcrumbStore();
	const isPlatformEnabledForMfa = usePermissions(ProductType.MOBILE_FLOW_ANALYZER);

	useEffect(() => {
		const mfaBreadcrumbRoutes = getMfaBreadcrumbRoutes(sessionId, sessionName);
		updateBreadcrumbRoutes(isPlatformEnabledForMfa ? mfaBreadcrumbRoutes : []);

		return () => {
			setBreadcrumbRoutes([]);
		};
	}, [
		updateBreadcrumbRoutes,
		setBreadcrumbRoutes,
		sessionId,
		sessionName,
		isPlatformEnabledForMfa
	]);
};
